import { ListTodo, type LucideIcon, Menu, PhoneMissed, Target, Users } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { NeedsAttentionNavBadge } from '@/components/needs-attention-nav-badge';
import { cn } from '@/lib/utils';

/**
 * The four an operator lives in, plus a way to everything else.
 *
 * Chosen for a day of selling, not for the shape of the menu: the dashboard
 * is the queue, leads are the work, contacts are who it is with, follow-ups
 * are what is owed. Everything else is a place you go occasionally, and
 * occasional belongs behind More.
 */
const TABS: { to: string; label: string; icon: LucideIcon; end?: boolean }[] = [
  // Today is home now — the Dashboard moved to /reports, under More.
  { to: '/', label: 'Today', icon: ListTodo, end: true },
  { to: '/leads', label: 'Leads', icon: Target },
  { to: '/contacts', label: 'Contacts', icon: Users },
  { to: '/calls', label: 'Calls', icon: PhoneMissed },
];

/**
 * A bottom bar, because a hamburger costs two taps to reach anywhere.
 *
 * Phone only — on a laptop the rail is always on screen and a second copy of
 * it would be noise.
 */
export function BottomNav({ onOpenMenu }: { onOpenMenu: () => void }) {
  return (
    <nav
      aria-label="Main"
      /*
       * `pb-[env(safe-area-inset-bottom)]` keeps the row clear of the home
       * indicator on a notched phone, where the bottom 34px are not tappable.
       */
      className={cn(
        'fixed inset-x-0 bottom-0 z-30 flex border-t border-line bg-surface md:hidden',
        'pb-[env(safe-area-inset-bottom)]',
      )}
    >
      {TABS.map(({ to, label, icon: Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            cn(
              // 56px tall: comfortably past the 44px tap-target floor.
              'relative flex h-14 flex-1 flex-col items-center justify-center gap-0.5 text-[11px] font-bold',
              isActive ? 'text-brand' : 'text-muted',
            )
          }
        >
          <span className="relative">
            <Icon className="size-5" aria-hidden="true" />
            {to === '/' && <NeedsAttentionNavBadge variant="corner" />}
          </span>
          {label}
        </NavLink>
      ))}

      <button
        type="button"
        onClick={onOpenMenu}
        className="flex h-14 flex-1 flex-col items-center justify-center gap-0.5 text-[11px] font-bold text-muted"
      >
        <Menu className="size-5" aria-hidden="true" />
        More
      </button>
    </nav>
  );
}
